/* eslint-disable no-useless-escape */
export default {
    contactNoRegex: /\(\+63\s?\d{1,2}\)\s?\d{4}\s?\d{4}|^[+]639[0-9]{9}$|^(\([0-9]{2,3}\)\s?[0-9]{3}[-\s][0-9]{4}\/)?\([0-9]{2,3}\)[-\s]?[0-9]{3,4}[-\s]?[0-9]{4}$/,
    messageRegex: /^([ÑñA-Za-z- .']{30,200})$/,
    nameRegex: /^([ÑñA-Za-z- .']{3,100})$/,
    passwordRegex: /[A-Za-z0-9<>().,"'=:;@$%*?!&_\-+|]{8,}/,
    passwordErrorMsg: 'Password must be at least 8 characters long and contain letters, numbers, and special characters.',
    dateFormatOptions: {
		year: 'numeric',
		month: 'short',
		day: '2-digit',
		weekday: 'short',
	}
};